import {Separator} from 'platform/components';
import {Text, VStack} from 'platform/foundation';
import {useDateTimeFormatter} from 'platform/locale';

import {isEmpty, isNil} from 'ramda';

import {useGetDelegatedUserAbsencesQuery} from '@dms/api/customer';
import i18n from '@dms/i18n';
import {getUserName} from '@dms/shared';

import {parseDate, RequiredTestIdProps, suffixTestId} from 'shared/web';

export function DelegatedAbsences(props: RequiredTestIdProps) {
  const format = useDateTimeFormatter();

  // The panel unmounts on close, so every open shows the current delegations.
  const {data: absences} = useGetDelegatedUserAbsencesQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  if (isNil(absences) || isEmpty(absences)) {
    return null;
  }

  const formatDateTime = (date: string) =>
    `${format('dateMedium', parseDate(date))} ${format('timeShort', parseDate(date))}`;

  return (
    <>
      <Separator spacing={4} />
      <VStack spacing={2} data-testid={suffixTestId('delegatedAbsences', props)}>
        <Text size="xSmall" color="secondary">
          {i18n.t('entity.userAbsence.labels.delegatedAbsencesTitle')}
        </Text>
        {absences.map((absence) => (
          <VStack key={absence.id}>
            <Text size="small" alternative overflowWrap="anywhere">
              {getUserName(absence.user) ?? absence.user.email}
            </Text>
            <Text size="xSmall" color="secondary">
              {isNil(absence.dateTo)
                ? i18n.t('entity.userAbsence.labels.delegatedAbsenceOpenEnded', {
                    date: formatDateTime(absence.dateFrom),
                  })
                : i18n.t('entity.userAbsence.labels.delegatedAbsenceRange', {
                    dateFrom: formatDateTime(absence.dateFrom),
                    dateTo: formatDateTime(absence.dateTo),
                  })}
            </Text>
          </VStack>
        ))}
      </VStack>
    </>
  );
}
